t = require('views/internal/teacup-with-helpers')('member_on_card')
memberTemplate = require('./member')

module.exports = t.renderable ({ avatarHash, fullName, id, initials, isDeactivated, isBoardAdmin, isOrganizationAdmin, isVirtual, username }) ->
  t.div '.member.js-member-on-card-menu', { class: t.classify({ 'member-deactivated': isDeactivated, 'member-virtual': isVirtual }), 'data-idmem': id }, ->
    memberTemplate({
      avatarHash
      fullName
      initials
      isDeactivated
      isBoardAdmin
      isOrganizationAdmin
      username
    })



// WEBPACK FOOTER //
// ./app/scripts/views/templates/member_on_card.coffee